import { render, staticRenderFns } from "./DailySync.vue?vue&type=template&id=ebfb23b0&scoped=true&"
import script from "./DailySync.vue?vue&type=script&lang=js&"
export * from "./DailySync.vue?vue&type=script&lang=js&"
import style0 from "./DailySync.vue?vue&type=style&index=0&id=ebfb23b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfb23b0",
  null
  
)

export default component.exports